export const MEMORY_COLS = ["M", "N"];

export const MEMORY_TABLE_NAME_COL_IDX = 0;
export const MEMORY_TABLE_VALUE_COL_IDX = 1;

export const MEMORY_TABLE_NAME = "MemoryTable";

export enum MemoryTableColsNames {
  STAGING_VALUES = "staging values",
  SAVED_VALUES = "values",
  AUTO_UPDATE = "auto-update",
}

export const MEMORY_TABLE_ROWS_IDX = {
  [MemoryTableColsNames.STAGING_VALUES]: 0,
  [MemoryTableColsNames.SAVED_VALUES]: 1,
  [MemoryTableColsNames.AUTO_UPDATE]: 2,
};
